var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('component-page', {
    attrs: {
      "title": "Aspect ratio"
    },
    scopedSlots: _vm._u([{
      key: "basicUsage",
      fn: function fn() {
        return [_c('div', {
          staticClass: "aspect-ratio"
        }, [_c('div', {
          staticClass: "aspect-ratio__content"
        }, [_vm._v(" This block will always be 16/9 until it is overflowed ")])])];
      },
      proxy: true
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }